import { render, staticRenderFns } from "./DataImportSidebar.vue?vue&type=template&id=75406454&scoped=true"
import script from "./DataImportSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./DataImportSidebar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DataImportSidebar.vue?vue&type=style&index=0&id=75406454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75406454",
  null
  
)

export default component.exports